// extracted by mini-css-extract-plugin
module.exports = {"pgOne":"tips_pgOne__ZKCbd","exImg":"tips_exImg__3hHfe","fibText":"tips_fibText__3vHYf","fibDes":"tips_fibDes__3uLES","exDes":"tips_exDes__1PWMp","pgTwo":"tips_pgTwo__3lEtp"};